<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="群名称">
                <a-input
                  placeholder="输入群名称查询"
                  v-model="queryParam.groupName"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12">
              <a-form-item label="创建人">
                <a-input
                  placeholder="输入创建人查询"
                  v-model="queryParam.founder"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <span
                style="float: left;overflow: hidden;"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;
          <a style="font-weight: 600">{{ selectedcount }}</a
          >项&nbsp;&nbsp;
          <a style="margin-left: 24px" @click="clearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          bordered
          size="middle"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :rowKey="r => r.chat_id"
          @change="handleTableChange"
        >
          <span slot="tag" slot-scope="text, record">
            <a v-if="record.label.length > 0 ? false : true">-</a>
            <a-tag
              color="#108ee9"
              v-for="item in record.label"
              :key="item"
              v-else
              >{{ item }}</a-tag
            >
          </span>
        </a-table>
      </div>
    </div>

    <div class="drawer-bootom-button" style="text-align: right;">
      <a-button @click="send" type="primary" :loading="confirmLoading"
        >群发</a-button
      >
    </div>
  </a-card>
</template>

<script>
import { postTag, getFileAccessHttpUrl } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';
import { getAction } from '../../../api/manage';
let groupSendMaterialId = sessionStorage.getItem('groupSendMaterialId');

export default {
  name: 'CustomerGroupSendList',
  mixins: [JeecgListMixin],
  data: function() {
    return {
      byCus: '',
      description: '',
      queryParam: {
        userId: this.$route.query.userId,
        tag: ''
      },
      groupSendMaterialId,
      selectedRowKeys: [],
      allSelectedRows: [],
      external_userid: '',
      records: [],
      view: {
        other: '',
        avatar: '',
        name: '',
        gender: '',
        type: '',
        phone: '',
        corp_name: '',
        grade: '',
        hobby: '',
        label: ''
      },
      labels: [],
      columns: [
        {
          title: '群名称',
          align: 'center',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '状态',
          align: 'center',
          width: 100,
          dataIndex: 'status'
        },
        {
          title: '创建人',
          align: 'center',
          width: 120,
          dataIndex: 'ownerName'
        },

        {
          title: '创建时间',
          align: 'center',
          width: 80,
          dataIndex: 'create_time',
          sorter: true
        },
        {
          title: '是否发送',
          align: 'center',
          width: 100,
          dataIndex:
            'judgeCurrentGroupChatIsSuccessReceiveAppointGroupSendMaterialMessage',
          customRender: function(text, record, index) {
            if (text) {
              return '已发送';
            } else {
              return '未发送';
            }
          }
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          `/wechatwork/customerGroupChat/data`
      },
      confirmLoading: false
    };
  },
  computed: {
    selectedcount() {
      return this.allSelectedRows.length < 1
        ? 0
        : this.allSelectedRows
            .map(e => e.selectedRows.length)
            .reduce((a, b) => a + b);
    }
  },
  created() {},
  watch: {
    'ipagination.current': function() {
      this.selectedRowKeys = this.allSelectedRows[this.ipagination.current]
        ? this.allSelectedRows[this.ipagination.current].selectedRows
        : [];
    }
  },
  // inject: ['reload'],
  props: {
    value: String
  },
  methods: {
    send() {
      if (this.allSelectedRows.length == 0) {
        // console.log(1111);
        this.$message.warning('请选择客户、客户群！');
        return false;
      }
      this.confirmLoading = true;
      const userIds = [];
      for (const pi in this.allSelectedRows) {
        const p = this.allSelectedRows[pi];
        console.log(p, p.selectedRows, Array.isArray(p.selectedRows));
        p &&
          p.selectedRows &&
          p.selectedRows.forEach(e => {
            if (userIds.indexOf(e.owner) == -1) {
              userIds.push(e.owner);
            }
          });
      }
      postTag(
        process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/createGroupMsg',
        {
          chatType: '1',
          id: this.value,
          userIds
        }
      )
        .then(res => {
          console.log(res);
          if (res.success) {
            this.close();
            this.$message.success('发送成功');
          } else {
            this.$message.warning(res.message);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
          this.$message.error('发送失败');
        });
    },
    clearSelected() {
      this.allSelectedRows = [];
      this.onClearSelected();
    },
    onSearch() {},
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.$set(this.allSelectedRows, this.ipagination.current, {
        selectedRowKeys,
        selectedRows
      });
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    viewLabel(key) {
      this.$refs.customerWindow.add(key, this.selectedRowKeys);
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.departList = [];
      this.checkedKeys = [];
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
